import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import ComplimentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/complimentImagesIcon.svg?react';
import DocumentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/documentImagesIcon.svg?react';
import VehicleImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/vehicleImagesIcon.svg?react';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import getBodyAdjusterImageTabsAlertsQueryOptions from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterImageTabsAlerts/getBodyAdjusterImageTabsAlertsQueryOptions';
import { getBodyDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImages/getBodyDamagedAdjusterImagesQueryOptions';
import { getBodyAdjusterImagesTabsOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImagesTabs/getBodyAdjusterImagesTabsOptions';
import { BodyAdjusterImageTabType } from '@/modules/adjusterReportModules/Insurer-information/types/Bodyimages';
import OfflineShowPhotoInformationModal from '@/modules/OfflineFiles/components/modals/OfflineShowPhotoInformationModal';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { getHasOfflineShootingQueryOptions } from '@/modules/OfflineFiles/queries/getHasOfflineShooting/getHasOfflineShootingQueryOptions';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title=" تصاویر / بیمه گذار" header="titleHeader">
      <BodyAdjusterImagesTabs />
    </MainLayout>
  );
};

const BodyAdjusterImagesTabs = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { resetCameraStore } = useImageFlowStore();
  const { resetDamagedPoints } = useDamagedPoints();
  const { closeModal, open, openModal } = useModal();
  const { getCurrentFileOfflineImages } = useGetOfflineImages();

  const { data: offlineShootingData } = useQuery(
    getHasOfflineShootingQueryOptions({
      id: id!,
      userType: 'body',
    }),
  );

  const { data: vehicleImages, isPending: imagesLoading } = useQuery(
    getBodyDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: true,
    }),
  );

  const { data, isPending: getDataLoading } = useQuery(
    getBodyAdjusterImagesTabsOptions({
      id: +id!,
    }),
  );

  const { isPending } = useQuery(
    getBodyAdjusterImageTabsAlertsQueryOptions({
      id: +id!,
    }),
  );
  const renderRoute = async (item: BodyAdjusterImageTabType) => {
    let hasOffline = false;
    if (
      item.name === 'vehicle_image' &&
      offlineShootingData?.has_offline_shooting
    ) {
      hasOffline = (await getCurrentFileOfflineImages({})).hasOffline;
      if (!vehicleImages?.vehicle.length && !hasOffline) {
        return openModal();
      }
    }
    const BODY_DAMAGE_IMAGES = ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES(
      { id: id! },
    );
    let tabIcon: Record<BodyAdjusterImageTabType['name'], string> = {
      additional_image: item.editable
        ? BODY_DAMAGE_IMAGES.ADJUSTER_ADDITIONAL.edit
        : BODY_DAMAGE_IMAGES.ADJUSTER_ADDITIONAL.show,
      document_image: item.editable
        ? BODY_DAMAGE_IMAGES.ADJUSTER_DOCUMENT.edit
        : BODY_DAMAGE_IMAGES.ADJUSTER_DOCUMENT.show,
      vehicle_image: item.editable
        ? !vehicleImages?.vehicle?.length && !hasOffline
          ? BODY_DAMAGE_IMAGES.ADJUSTER_VEHICLE.damagedPoints
          : BODY_DAMAGE_IMAGES.ADJUSTER_VEHICLE.serverPreviewImages
        : BODY_DAMAGE_IMAGES.ADJUSTER_VEHICLE.showServerPreviewImages,
    };
    return tabIcon[item.name];
  };
  useEffect(() => {
    resetDamagedPoints();
    resetCameraStore();
  }, []);
  const goToFile = async (item: BodyAdjusterImageTabType) => {
    const path = await renderRoute(item);
    if (path) {
      navigate(path);
    }
  };
  if (isPending || getDataLoading || imagesLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        mt="10rem"
      >
        <CircularLoading color="colors.purple-primary" />
      </Box>
    );
  }

  return (
    <>
      <Box pt="2rem" mt="4rem">
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            position: 'relative',
            top: '-5px',
          })}
        >
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            })}
          >
            <TitleDescription>تصاویر کارشناس</TitleDescription>
            <Box>
              {data?.map((item, index) =>
                item.name === 'vehicle_image' && !item.is_card_active ? null : (
                  <CardButton
                    key={item?.name}
                    cardProps={{
                      className: css({
                        marginY: '1rem',
                        marginTop: index === 0 ? '0rem' : '1rem',
                        marginBottom:
                          index === data.length - 1 ? '0rem' : '1rem',
                      }),
                      onClick: () => goToFile(item),
                    }}
                    hasArrow
                    renderIcon={() => renderIcon(item?.name)}
                    title={item?.fa_name}
                  />
                ),
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <OfflineShowPhotoInformationModal
        confirmButtonText="شروع فرایند عکس برداری"
        open={open}
        closeModal={() => {
          closeModal();
          navigate(
            ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
              id: id!,
            }).ADJUSTER_VEHICLE.damagedPoints,
          );
        }}
      />
    </>
  );
};

const renderIcon = (tabName: BodyAdjusterImageTabType['name']) => {
  let tabIcon: Record<BodyAdjusterImageTabType['name'], React.JSX.Element> = {
    additional_image: <ComplimentImagesIcon />,
    document_image: <DocumentImagesIcon />,
    vehicle_image: <VehicleImagesIcon />,
  };
  return tabIcon[tabName];
};
